import { Subject ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class VgControlsHidden {
    isHidden: Observable<boolean>;

    private isHiddenSubject: Subject<boolean> = new Subject<boolean>();
    private shouldHidden: Subject<boolean> = new Subject<boolean>();
    private shouldShow: Subject<boolean> = new Subject<boolean>();
    captureControlsEvent: Subject<boolean> = new Subject<boolean>();

    constructor() {
        this.isHidden = this.isHiddenSubject.asObservable();
    }

    state(hidden: boolean) {
        this.isHiddenSubject.next(hidden);
    }

    force(hidden: boolean)
    {
        this.shouldHidden.next(hidden);
    }

    show() {
        this.shouldShow.next(true);
    }

    captureControls()
    {
        this.captureControlsEvent.next(true);
    }
    releaseControls()
    {
        this.captureControlsEvent.next(false);
    }

    // subscriptForce(func)
    // {
    //     return this.shouldHidden.subscribe(func);
    // }

    // subscriptShow(func) {
    //     return this.shouldShow.subscribe(func);
    // }

    
}
